import { Button, Modal } from 'react-bootstrap';
import { formatDate } from 'date-utils-2020';
import { Translator, DocumentView, UserImagePreview } from '@components';
import PhysicalInvestor from '../../InvestorDetails/PhysicalInvestor'

const Issuer = ({ issuer, handleApprove, handleReject }) => {
  return (
    <div className="col-xl-12 col-md-12">
      <div className="card justify-content-center">
        <div className="card-body d-flex">
          <UserImagePreview url={issuer?.image} />
          <div className="w-100 ps-4">
            <div className="d-flex justify-content-between">
              <div className="">
                <h4 className="font-w700"> {issuer.corporateName} </h4>
                {issuer.businessLine ? <h5> {issuer.businessLine} </h5> : ""}
                <div className="d-flex align-items-center pe-4 mb-2">
                  {issuer.shareCapital ?
                    <span>
                      <Translator path="pages.issuers.shareCapital" />
                      {` ${issuer.shareCapital?.toLocaleString('pt-BT', { style: 'currency', currency: 'BRL' })}`}
                    </span>
                    : ""
                  }
                </div>
                <div className="d-flex align-items-center pe-4 mb-2">
                  <span className="time py-0">
                    <Translator path="pages.issuers.createdAt" />
                    {` ${formatDate(issuer.createdAt, 'dd/MM/yyyy')}`}
                  </span>
                </div>
                <div className="d-flex align-items-center pe-4 mb-2">
                  <span className="time py-0">
                    <Translator path="pages.issuers.cnpj" />
                    {` ${issuer.cnpj}`}
                  </span>
                </div>
                {
                  issuer.foundationDate ?
                    <div>
                      <Translator path="pages.issuers.foundationDate" />

                      <span>
                        {` ${formatDate(issuer.foundationDate, 'dd/MM/yyyy')}`}
                      </span>
                    </div>
                    : ""
                }
                {issuer.simpleDescription ?
                  <div>
                    <div className="d-flex align-items-center pe-4 ">
                      <h6> <Translator path="pages.issuers.simpleDescription" /></h6>
                    </div>
                    <div className="d-flex align-items-center pe-4 mb-2">
                      <span>
                        {` ${issuer.simpleDescription}`}
                      </span>
                    </div>
                  </div>
                  : ""
                }
                {issuer.detailedDescription ?
                  <div>
                    <div className="d-flex align-items-center pe-4">
                      <h6> <Translator path="pages.issuers.detailedDescription" /></h6>
                    </div>
                    <div className="d-flex align-items-center pe-4 mb-2">

                      <span>
                        {` ${issuer.detailedDescription}`}
                      </span>
                    </div>
                  </div>
                  : ""
                }


              </div>
              {issuer?.status == 'IN_ANALYSIS' ?
                <div className="d-grid align-items-center pe-5 mb-2">
                  {
                    handleApprove ?
                      <Button className="pe-4 mb-2 d-flex align-items-center " onClick={handleApprove}>
                        <i className="material-icons">check</i>
                        <Translator path="pages.issuers.approve" />
                      </Button>
                      : ""
                  }
                  {
                    handleReject ?
                      <Button variant="outlined" className="d-flex align-items-center ">

                        <i className=" material-icons">close</i>
                        <Translator path="pages.issuers.reject" />
                      </Button> : ""
                  }
                </div> : ""
              }
            </div>

            <div className="d-flex flex-wrap pt-4">
              {
                issuer.email ?
                  <div className="d-flex align-items-center pe-4 mb-2">
                    <div className="pe-2">
                      <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M20 4.5H4C3.20435 4.5 2.44129 4.81607 1.87868 5.37868C1.31607 5.94129 1 6.70435 1 7.5V17.5C1 18.2956 1.31607 19.0587 1.87868 19.6213C2.44129 20.1839 3.20435 20.5 4 20.5H20C20.7956 20.5 21.5587 20.1839 22.1213 19.6213C22.6839 19.0587 23 18.2956 23 17.5V7.5C23 6.70435 22.6839 5.94129 22.1213 5.37868C21.5587 4.81607 20.7956 4.5 20 4.5ZM21 17.25L16.1 12.85L21 9.42V17.25ZM3 9.42L7.9 12.85L3 17.25V9.42ZM9.58 14.03L11.43 15.32C11.5974 15.4361 11.7963 15.4984 12 15.4984C12.2037 15.4984 12.4026 15.4361 12.57 15.32L14.42 14.03L19.42 18.5H4.6L9.58 14.03ZM4 6.5H20C20.1857 6.50149 20.3673 6.55467 20.5245 6.65358C20.6817 6.75249 20.8083 6.89322 20.89 7.06L12 13.28L3.11 7.06C3.19171 6.89322 3.31826 6.75249 3.47545 6.65358C3.63265 6.55467 3.81428 6.50149 4 6.5Z" fill="#F79F19" />
                      </svg>
                    </div>
                    <h5 className="font-w400 mb-0">{issuer.email} </h5>
                  </div> : ""
              }
              {
                issuer.phone ?
                  <div className="d-flex align-items-center pe-4 mb-2">
                    <div className="pe-2">
                      <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M19.4401 13.5004C19.2201 13.5004 18.9901 13.4304 18.7701 13.3804C18.3246 13.2822 17.8868 13.1518 17.4601 12.9904C16.9962 12.8216 16.4862 12.8304 16.0284 13.015C15.5706 13.1996 15.1972 13.547 14.9801 13.9904L14.7601 14.4404C13.7861 13.8985 12.8911 13.2256 12.1001 12.4404C11.3149 11.6494 10.6419 10.7544 10.1001 9.78036L10.5201 9.50036C10.9635 9.28327 11.3109 8.90989 11.4955 8.45205C11.6801 7.99421 11.6889 7.48427 11.5201 7.02036C11.3613 6.59278 11.231 6.15515 11.1301 5.71036C11.0801 5.49036 11.0401 5.26036 11.0101 5.03036C10.8887 4.32598 10.5197 3.6881 9.96972 3.2316C9.41972 2.77509 8.7248 2.52997 8.0101 2.54036H5.0101C4.57913 2.53631 4.15235 2.62517 3.75881 2.80089C3.36527 2.9766 3.01421 3.23505 2.72953 3.55864C2.44485 3.88222 2.23324 4.26335 2.10909 4.67607C1.98494 5.08879 1.95118 5.52342 2.0101 5.95036C2.54284 10.1397 4.45613 14.0322 7.44775 17.013C10.4394 19.9938 14.3388 21.8929 18.5301 22.4104H18.9101C19.6475 22.4114 20.3595 22.1409 20.9101 21.6504C21.2265 21.3674 21.4792 21.0205 21.6516 20.6327C21.8239 20.2448 21.9121 19.8248 21.9101 19.4004V16.4004C21.8979 15.7057 21.6449 15.0369 21.1944 14.508C20.744 13.9791 20.1239 13.623 19.4401 13.5004ZM19.9401 19.5004C19.9399 19.6423 19.9095 19.7827 19.8509 19.912C19.7923 20.0413 19.7068 20.1566 19.6001 20.2504C19.4884 20.3468 19.3577 20.4189 19.2165 20.462C19.0753 20.505 18.9267 20.5181 18.7801 20.5004C15.035 20.0202 11.5563 18.3068 8.89282 15.6306C6.2293 12.9545 4.53251 9.46769 4.0701 5.72036C4.05419 5.57387 4.06813 5.42569 4.1111 5.28475C4.15407 5.14381 4.22517 5.01304 4.3201 4.90036C4.41381 4.79369 4.52916 4.7082 4.65848 4.64957C4.7878 4.59095 4.92812 4.56054 5.0701 4.56036H8.0701C8.30265 4.55518 8.52972 4.63124 8.71224 4.77543C8.89476 4.91962 9.02131 5.12293 9.0701 5.35036C9.1101 5.62369 9.1601 5.89369 9.2201 6.16036C9.33562 6.6875 9.48936 7.20554 9.6801 7.71036L8.2801 8.36036C8.1604 8.41528 8.05272 8.4933 7.96326 8.58995C7.87379 8.6866 7.8043 8.79997 7.75877 8.92355C7.71324 9.04713 7.69257 9.17849 7.69795 9.31008C7.70332 9.44167 7.73464 9.5709 7.7901 9.69036C9.2293 12.7731 11.7073 15.2512 14.7901 16.6904C15.0336 16.7904 15.3066 16.7904 15.5501 16.6904C15.6748 16.6458 15.7894 16.5768 15.8873 16.4875C15.9851 16.3983 16.0643 16.2905 16.1201 16.1704L16.7401 14.7704C17.2571 14.9552 17.7847 15.1088 18.3201 15.2304C18.5868 15.2904 18.8568 15.3404 19.1301 15.3804C19.3575 15.4291 19.5608 15.5557 19.705 15.7382C19.8492 15.9207 19.9253 16.1478 19.9201 16.3804L19.9401 19.5004Z" fill="#FF5B5B" />
                      </svg>
                    </div>
                    <h5 className="font-w400 mb-0">{issuer.phone}</h5>
                  </div> : ""
              }
              {
                issuer.website ? (
                  <div className="d-flex align-items-center pe-4 mb-2">
                    <div className="pe-2">
                      <i class=" fa fa-link m-0"></i>
                    </div>
                    <a href={issuer.website} target="_blank" rel="noopener noreferrer">
                      <h5 className="font-w400 mb-0">{issuer.website}</h5>
                    </a>
                  </div>
                ) : ""
              }
            </div>

            <div className="d-grid pt-12">
              <h6> <Translator path="pages.issuers.documentation" /> </h6>
              <div className="d-grid pt-12">

                <h6 className="font-w400"><Translator path="pages.issuers.socialContract" /> </h6>
                <DocumentView
                  url={issuer?.socialContract?.link}
                />
              </div>
              <h6 className="font-w400"><Translator path="pages.issuers.user" /> </h6>

              {
                <div className="d-flex pt-12">
                  {issuer.issuerLogins ?
                    issuer.issuerLogins.map((login) => (
                      <PhysicalInvestor
                        investor={{ physicalUser: login, image: login.image }}
                        showDocuments={false}
                      />
                    ))
                    : ""
                  }
                </div>
              }
            </div>
          </div>
        </div>
      </div>
    </div >
  )
}

export default Issuer;